// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__bIeFc","menu":"Navbar_menu__el2Gc","menubutton":"Navbar_menubutton__ZLxVY","activepage":"Navbar_activepage__AE8I6"};